var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1700_4499)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2319,
    r: 19.5455,
    fill: "#fbfbfb",
    stroke: "#C1C5CF",
    strokeWidth: 0.909091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 27.4319C13.8612 26.9154 16.021 24.5385 16.654 24.5385H23.3464C24.2636 24.5385 26.136 26.5088 26.6 27.2033M29.6 20.2319C29.6 25.5338 25.3019 29.8319 20 29.8319C14.6981 29.8319 10.4 25.5338 10.4 20.2319C10.4 14.9299 14.6981 10.6319 20 10.6319C25.3019 10.6319 29.6 14.9299 29.6 20.2319ZM23.4388 16.9598C23.4388 15.1283 21.8927 13.6319 20.0003 13.6319C18.1079 13.6319 16.5617 15.1283 16.5617 16.9598C16.5617 18.7913 18.1079 20.2878 20.0003 20.2878C21.8927 20.2878 23.4388 18.7913 23.4388 16.9598Z",
    stroke: "#F9009E",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1700_4499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.231873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/PersonalInfo.fc92a101f6a78a3fce5fcb9f5873835e.svg";
export { ForwardRef as ReactComponent };